import React from 'react';
import CustomAddIcon from '../icon/CustoAddIcon';
import BasicButton from './BasicButton';

const CreateButton = ({ text, sx = {}, onClick, ...props }) => {
  const handleOnClick = () => {
    onClick();
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    };
    scrollToTop();
    setTimeout(scrollToTop, 50);
  };
  const renderStartIcon = () => {
    return <CustomAddIcon size={16} />;
  };

  return (
    <BasicButton
      variant="outlined"
      startIcon={renderStartIcon()}
      onClick={handleOnClick}
      sx={{
        ...sx,
      }}
      {...props}
    >
      {text}
    </BasicButton>
  );
};

export default CreateButton;
